import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appTrimInput]'
})
export class TrimInputDirective {

    private innerInput?: HTMLInputElement;

    constructor(private readonly el: ElementRef) {}

    ngAfterViewInit(): void {
        // 這裡要等下一個 tick，確保 p-autoComplete 生成完畢
        // 先檢查是不是有子功能視窗，如果沒有則抓取主畫面物件
        setTimeout(() => {
            this.innerInput = this.el.nativeElement.querySelector('input') ?? this.el.nativeElement;
        });
    }

    // 當元素失去焦點時自動 trim
    @HostListener('blur')
    onBlur() {
       this.trimAndEmit();
    }

    // paste 時修正值（貼上後再處理）
    @HostListener('paste')
    onPaste() {
        // 使用 setTimeout 等貼上結束再執行 trim
        setTimeout(() => this.trimAndEmit(), 0);
    }

    private trimAndEmit() {
        const value = this.innerInput?.value;
        if (this.innerInput?.value && typeof value === 'string') {
            this.innerInput.value = value.trim();
            const event = new Event('input', { bubbles: true });
            this.innerInput.dispatchEvent(event); // 讓 Angular ngModel 同步更新
        }
    }
}
